import React from 'react';

import { ChannelKey } from 'app-types';
import Image from 'components/common/Image';
import { useKsNetwork } from 'hooks/kitchenSink';

interface BrandLogoProps {
  className?: string | null;
  brand?: ChannelKey | null;
  fixedSize?: boolean;
}

const BrandLogo = ({
  className = null,
  brand = null,
  fixedSize = true,
}: BrandLogoProps) => {
  const format = fixedSize ? 'logoFixedSmallUrl' : 'logoSmallUrl';
  const urls = useKsNetwork(brand);
  const logoSrc = urls && urls[format as keyof ReturnType<typeof useKsNetwork>];
  if (!logoSrc) return null;
  return (
    <Image
      alt="brand logo"
      src={logoSrc}
      className={className}
      data-testid="brand-logo"
    />
  );
};

export default React.memo(BrandLogo);
